import { RootState } from '@store/reducers';
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import './abha.css';
import Button from '@components/common/Button';
import InputFieldsComponent from '@components/common/InputFieldsSmall';
import endpoints from '@config/endpoints';
import { getData, postDataJSON } from '../../../../services/CommonApiService';
import { getUserConsentLanguage } from '@services/childApiServices';
import { useDispatch } from 'react-redux';
import { setBeneficiaryAbha, setBeneficiaryMobileNumber, setTsnID, setConsentLanguage } from '@store/actions/beneficiaryAction';
import { encode, decode, encodeWithKeyAndShift, decryptData, decodeWithKeyAndShift } from '../../../../utils/base64Utils';
import Spinner from "@components/common/Spinner";
import { errorLogger } from '@utils/applicationLogUtils';
import { isValueContainsOnlyDigits } from '@utils/hrpConditionCheck';
import { sanitizeName } from '@utils/childUtils';
import CheckboxComponent from '@components/common/CheckBox';
import { toast } from 'react-toastify';
import { benef_error_const } from '@constants/beneficiaryConstant';
import { useOtpCooldown, isOtpRateLimited, isOtpRateLimitedError } from '@hooks/useOtpCooldown';
import { otpCooldownMessage } from '@constants/appConstants';


interface abhaProps {
    handleClose: (authType: string) => void;
};

const VerificationAbha = ({ handleClose }: abhaProps) => {
    const [abhaErrorMessage, setAbhaErrorMessage] = useState<string>('');
    const [inputAbha, setInputAbha] = useState<string>('');
    const [isAbhaError, setIsAbhaError] = useState<boolean>(false);
    const [checkAbhaId, setCheckAbhaId] = useState<boolean>(false);
    const [showSpinner, setSHowSpinner] = useState<boolean>(false);
    const beneficiary = useSelector((state: RootState) => state.beneficiary);;
    const [abhaName, setAbhaName] = useState<string>('');
    const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
    const [abhaNameErrorMessage, setAbhaNameErrorMessage] = useState<string>('');
    const [isAbhaNameError, setIsAbhaNameError] = useState<boolean>(false);
    const [consentCheckbox, setConsentCheckbox] = useState<boolean>(false);
    const [consentShow, setConsentShow] = useState<boolean>(false);
    const [checkedState, setCheckedState] = useState<boolean[]>([]);
    const [consentLanguageData, setConsentLanguageData] = useState<any>([]);


    const dispatch = useDispatch();
    const { secondsLeft, isCoolingDown, startCooldown } = useOtpCooldown(inputAbha);
    const isAllChecked = checkedState?.every((checked) => checked);

     const createErrorMessage = (abdmMessage: string, rchMessage?: string) => (
            <div>
                <p><strong>ABDM:</strong> {abdmMessage}</p>
                {rchMessage && <p><strong>JANANI:</strong> {rchMessage}</p>}
            </div>
        );
    
        const handleError = (message: string, rchMessage?: string) => {
            const errorMessage = createErrorMessage(message, rchMessage);
            toast.error(errorMessage, {
                position: "top-center",
            });
            setSHowSpinner(false);
        };

    useEffect(() => {
        getConsentLanguage();
    }, []);

    const getConsentLanguage = async () => {
        try {
            const type = "Beneficiary"
            const consent = "abha"
            const response = await getUserConsentLanguage(type, consent);
            setConsentLanguageData(response);
            const res: any = response?.data[0]?.length // 6
            setCheckedState(new Array(res).fill(false))
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const handleFormChangeAbha = (event: any) => {
        const isValue = isValueContainsOnlyDigits(event);
        setIsAbhaError(false);
        setAbhaErrorMessage('');
        if (isValue) {
            setInputAbha(event);
        } else if (event.length === 0) {
            setInputAbha("");
        }
    };

    const handleAbhaNameChange = (event: any) => {
        const sanitizedValue = sanitizeName(event);
        setAbhaName(sanitizedValue);
        if (sanitizedValue.length === 0) {
            setConsentCheckbox(false);
        }
    }

    const formatNumber = (num: string): string => {
        // Split the number into parts
        const part1 = num.slice(0, 2);
        const part2 = num.slice(2, 6);
        const part3 = num.slice(6, 10);
        const part4 = num.slice(10);

        // Join the parts with hyphens
        return `${part1}-${part2}-${part3}-${part4}`;
    };
    const handleAuthClick = (authType: string) => {
        handleClose(authType);
    };

    const handleSaveAbha = async () => {
        let tempError = false;
        if (!/^\d+$/.test(inputAbha)) {
            setAbhaErrorMessage("Entered ABHA Number is  invalid .Enter Valid a ABHA Number")
            tempError = true
        }
        if (inputAbha == '00000000000000') {
            setAbhaErrorMessage("ABHA Cannot be all Zeros. Enter a valid ABHA Number.")
            tempError = true
        }
        if (inputAbha.length !== 14) {
            setAbhaErrorMessage("ABHA Number Must Contain 14 Digits. Enter a valid ABHA Number.")
            tempError = true
        }
        setIsAbhaError(tempError);
        if (tempError) {
            return;
        }
        if (isCoolingDown) {
            handleError(otpCooldownMessage);
            return;
        }
        const formattedNum = formatNumber(inputAbha);
        const data = {
            "abhaNumber": formattedNum
        }
        dispatch(setBeneficiaryAbha(data));
        try {
            setSHowSpinner(true);
            const dataAbha = {
                abhaId: inputAbha
            }
            const encodedNumber = encodeWithKeyAndShift(JSON.stringify(dataAbha));
            const abhaResponse = await postDataJSON<any>(endpoints.checkAbhaIdExist, { data: encodedNumber })
            const decodedResponse = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
            const abhaRes = decodedResponse[0];
            const abhaFlag = abhaRes.check_abha_id_exists;
            setSHowSpinner(false);
            if (abhaFlag) {
                setAbhaErrorMessage("Entered Abha number already linked.")
                setIsAbhaError(true);
                setCheckAbhaId(false);
            }
            else {
                if (beneficiary.beneficiaryAuthType === "OTP") {
                    try {
                        setSHowSpinner(true);
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const abhaResponse = await postDataJSON<any>(`${endpoints.sendOtpToAbhaToVerifyAbha}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
                        const res = decodedData;
                        setSHowSpinner(false);
                        if (res.txnId) {
                            const consentDetails = [
                                ...consentLanguageData.data[0].map((item :any)=> ({
                                    consent_template_id: item.consent_template_id,
                                    conscent_template_content:  item?.consent_template_content.includes('{#var1#}')
                                    ? item?.consent_template_content.replace(
                                    '{#var1#}',
                                    `${userDetail.first_name || ''} ${userDetail.last_name || ''}`
                                    ):
                                    item?.consent_template_content?.includes('{#name#}')?
                                    item?.consent_template_content.replace(
                                    '{#name#}',
                                    `${abhaName.trim() || ''}`
                                    )
                                : item?.consent_template_content
                                })),
                              ];
                            dispatch(setConsentLanguage(consentDetails));
                            dispatch(setTsnID(res.txnId));
                            dispatch(setBeneficiaryMobileNumber(res.message))
                            handleAuthClick('submit');
                        }
                        else if (res?.message?.includes('multiple OTPs')) {
                            handleError(res.message, benef_error_const?.multipleOTP);
                        }
                        else if (res?.message?.includes('30 seconds')) {
                            handleError(res.message);
                        }
                        else if (res?.message?.includes('Runtime Error')) {
                            handleError(`${res?.code} - ${res.message}`, benef_error_const?.urlNotFound);
                        }
                        else if (res?.message?.includes('User not found')) {
                            handleError(`${res?.code} - ${res.message}`, benef_error_const?.provideCorrectAbha);
                        }
                        else if (res?.loginId?.includes('Invalid LoginId')) {
                            handleError(`${res?.loginId}`, benef_error_const?.provideCorrectAbha);
                        }
                        else if (res?.message?.includes('Missing Credentials')) {
                            handleError(`${res?.code} - ${res.description}`);
                        }
                        else if(res?.message?.includes('Too many request attempted')){
                            handleError(`${res?.message}`);
                        }
                        else {
                            handleError(res?.message ?? benef_error_const.genericAbdmMessage);
                        }
                    }
                    catch (error:any) {
                        if (isOtpRateLimitedError(error)) {
                            startCooldown();
                            handleError(otpCooldownMessage);
                            return;
                        }
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error));
                        const res = decodedData;
                        let catchErrorMessage = '';
                        if(res?.message && res?.code){
                            catchErrorMessage =`${res?.code} - ${res?.message}`
                        }else if(res?.message && !res?.code){
                            catchErrorMessage =`${res?.message}`
                        }else if(res?.loginId){
                            catchErrorMessage =`${res?.loginId}`
                        }else if(res?.Aadhaar){
                            catchErrorMessage =`${res?.Aadhaar}`
                        }else{
                            catchErrorMessage = benef_error_const.genericAbdmMessage
                        } 
                        handleError(catchErrorMessage);
                        errorLogger(res, "ABHA OTP Generation-sendOtpToAbhaToVerifyAbha");
                    }
                }

            }
        }
        catch (error: any) {
            handleError(benef_error_const.unableToverifyABHA)
            setSHowSpinner(false);
            errorLogger(error?.response?.data || error?.response || error)
        }
    }

    const showConsentForm = () => {
        if(consentLanguageData?.length === 0){
              toast.error("Unable to fetch consent details. Please try again later.", {
                position: "top-center",
              });
              getConsentLanguage();
              return;
        }
        setConsentShow(true);
    };

    const handleCheckboxChange = (index: number, checked: boolean) => {
        const updatedCheckedState = [...checkedState];
        updatedCheckedState[index] = checked;
        setCheckedState(updatedCheckedState);
    };

    const handleSelectAll = (checked: boolean) => {
        setCheckedState(new Array(checkedState?.length).fill(checked));
    };

    const handletoAadhar = () => {
        setConsentCheckbox(true);
        setConsentShow(false);
    };

    return (
        <div>
            {!consentShow &&
                <div className='abha_container'>
                    {!checkAbhaId && <div className='abha_id_container'>
                        <h4 className='abha_headings'>Register with ABHA Number ({beneficiary.beneficiaryAuthType})</h4>
                        <div className='abha_input_fields'>
                            <InputFieldsComponent
                                labelName="Enter ABHA Number"
                                placeholder={"Type Here"}
                                dataTestId="abha-number"
                                type={'text'}
                                isDisabled={false}
                                onChange={handleFormChangeAbha}
                                errorMessage={abhaErrorMessage}
                                value={inputAbha ? inputAbha : ''}
                                maximumLength={14}
                                inputType={isAbhaError ? 'error' : 'general'}
                                required={true}
                            />
                            <InputFieldsComponent
                                labelName="Enter ABHA Name"
                                placeholder={'Type Here'}
                                type={'text'}
                                isDisabled={false}
                                dataTestId="abha-name"
                                onChange={handleAbhaNameChange}
                                errorMessage={abhaNameErrorMessage}
                                inputType={isAbhaNameError ? 'error' : 'general'}
                                value={abhaName}
                                required={true}
                            />
                            <div className="aadhar_checkbox">
                                <CheckboxComponent
                                    className="align-item_check_box"
                                    checkBoxName=""
                                    disabled={false}
                                    onCheckboxChange={() => { }}
                                    placeCheckboxBefore={false}
                                    isChecked={consentCheckbox}
                                />
                                <p>
                                    I hearby confirm that I agree to the {' '}
                                    <button
                                        onClick={showConsentForm}
                                        className="aadhar_consent_form"
                                        disabled={!inputAbha.length || !abhaName.length}
                                    >
                                        Consent Process
                                    </button>{' '}
                                    for the verification of ABHA and linking with JANANI programme/application
                                </p>
                            </div>
                            <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
                        </div>
                    </div>}
                    <div className='abha_submit'>
                        {isCoolingDown && (
                            <p style={{ color: '#b42318', fontSize: '12px', margin: '8px 0 0' }}>
                                You can request for new OTP after {secondsLeft} seconds
                            </p>
                        )}
                        <Button
                            onClick={handleSaveAbha}
                            disabled={isCoolingDown ? true : inputAbha?.length > 0 && abhaName?.length>0 && consentCheckbox? false : true}
                            id="abha-beneficiary-submit"
                            buttonName={'Submit'}
                            colorType={'primary'}
                        />
                    </div>
                </div>
            }
            {consentShow && (
                <div className="aadhar_consent_form_enlarge">
                    <h1 className="aadhar_headings">Consent Process</h1>
                    <div className="consent_form_for_aadhar">
                        I hereby declare that:
                        {/* Select All Checkbox */}
                        <CheckboxComponent
                            isChecked={isAllChecked}
                            onCheckboxChange={handleSelectAll}
                            disabled={false}
                            className="consent-select-all"
                            checkBoxName="Select All"
                        />
                        {/* Individual Checkboxes */}
                        {consentLanguageData?.data[0]?.map((item: any, index: any) => (
                            <CheckboxComponent
                                key={index}
                                isChecked={checkedState?.[index]}
                                onCheckboxChange={(checked) =>
                                    handleCheckboxChange(index, checked)
                                }
                                disabled={false}
                                className={`consent-checkbox-item`}
                                checkBoxName={
                                    item?.consent_template_content.includes('{#var1#}')
                                      ? item?.consent_template_content.replace(
                                      '{#var1#}',
                                      `${userDetail.first_name || ''} ${userDetail.last_name || ''}`
                                      ):
                                      item?.consent_template_content?.includes('{#name#}')?
                                      item?.consent_template_content.replace(
                                      '{#name#}',
                                      `${abhaName.trim() || ''}`
                                      )
                                  : item?.consent_template_content
                                }
                            />
                        ))}
                    </div>
                    <div className="aadhar-submit">
                        <Button
                            onClick={handletoAadhar}
                            disabled={isAllChecked ? false : true}
                            id="aadhar-beneficiary-submit"
                            buttonName={'Submit'}
                            colorType={'primary'}
                            icon={''}
                            iconPosition={''}
                        />
                    </div>
                </div>
            )}
        </div>

    );
};

export default VerificationAbha;